export default "__VITE_ASSET__eGXD2wu8__"